import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["children", "style", "className", "title", "minWidth", "maxWidth", "selectedItem", "handleClose", "selectItem", "TitleIcon", "CloseButton"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback, forwardRef } from 'react';
import Box from '@rexlabs/box';
import { useStyles, useToken, StyleSheet, text, padding, margin, border, mq } from '@rexlabs/styling';
import { Breakpoints } from '@rexlabs/breakpoints';
import { Truncate } from '@rexlabs/text';
import Icons from '@rexlabs/icons';
import { DefaultCloseButton } from './close-button';
import { isRegularAcctionMenuItem, isCustomElementActionMenuItem } from '../types';
var ChevronLeft = Icons.ChevronLeft;
var defaultStyles = StyleSheet({
  menu: _objectSpread(_objectSpread({
    height: 'auto',
    overflow: 'hidden'
  }, border.styles({
    target: 'actionMenu.menu',
    all: {
      radius: 'l'
    }
  })), {}, {
    backgroundColor: function backgroundColor(_ref) {
      var token = _ref.token;
      return token('actionMenu.menu.background.color', token('color.container.static.default', 'white'));
    }
  }, mq.styles.combine([{
    queries: {
      maxWidth: function maxWidth(_ref2) {
        var token = _ref2.token;
        return token('actionMenu.breakpoint', token('breakpoint.s'));
      }
    },
    styles: _objectSpread(_objectSpread({
      position: 'absolute'
    }, border.styles({
      target: 'actionMenu.menu.mobile',
      top: {
        radius: 'l'
      }
    })), {}, {
      width: function width(_ref3) {
        var token = _ref3.token;
        return token('actionMenu.menu.mobile.width', '100vw');
      },
      maxHeight: function maxHeight(_ref4) {
        var token = _ref4.token;
        return token('actionMenu.menu.mobile.maxHeight', '100vh');
      },
      maxWidth: function maxWidth(_ref5) {
        var token = _ref5.token;
        return token('actionMenu.menu.mobile.maxWidth', '41.4rem');
      }
    })
  }, {
    queries: {
      minWidth: function minWidth(_ref6) {
        var token = _ref6.token;
        return token('actionMenu.breakpoint', token('breakpoint.s'));
      }
    },
    styles: {
      // Inherit the max height for this container from the popper
      maxHeight: 'inherit',
      minWidth: function minWidth(_ref7) {
        var token = _ref7.token;
        return token('actionMenu.menu.desktop.minWidth', '14rem');
      }
    }
  }])),
  titleContainer: _objectSpread(_objectSpread({
    display: 'flex',
    alignItems: 'center'
  }, padding.styles({
    target: 'actionMenu.menu.titleContainer',
    all: 'm'
  })), border.styles({
    target: 'actionMenu.menu.titleContainer',
    bottom: {
      width: 'thin',
      color: 'container.static.light'
    }
  })),
  titleContainerHasSelectedItem: {
    cursor: 'pointer'
  },
  title: _objectSpread({}, text.styles({
    target: 'actionMenu.menu.title',
    fallback: 'normal.bold'
  })),
  items: {
    overflow: 'auto',
    '&, & p': _objectSpread({}, text.styles({
      target: 'actionMenu.item.paragraph',
      fallback: 'normal.default',
      color: function color(_ref8) {
        var token = _ref8.token;
        return token('color.textStyle.body.default');
      }
    })),
    '& p': _objectSpread(_objectSpread({}, padding.styles({
      target: 'actionMenu.menu.paragraph',
      top: 'none',
      bottom: 'xs'
    })), {}, {
      '&:last-child': {
        paddingBottom: 0
      }
    }),
    '& a': _objectSpread(_objectSpread({
      display: 'block',
      width: '100%'
    }, text.styles({
      target: 'actionMenu.item.link',
      fallback: 'link.default.idle',
      color: function color(_ref9) {
        var token = _ref9.token;
        return token('color.textStyle.body.default');
      },
      textDecoration: function textDecoration() {
        return 'none';
      }
    })), {}, {
      // We have to override the color of the hover and focus
      // pseudo-classes with more specificity otherwise the
      // default behaviour will apply
      '&:hover': {
        color: 'inherit'
      },
      '&:focus': {
        color: 'inherit',
        boxShadow: 'none'
      }
    })
  },
  backButton: _objectSpread({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }, margin.styles({
    target: 'actionMenu.menu.backButton',
    right: 's'
  })),
  hidden: {
    display: 'none'
  }
});
export var Menu = /*#__PURE__*/forwardRef(function Menu(_ref10, ref) {
  var children = _ref10.children,
      style = _ref10.style,
      className = _ref10.className,
      title = _ref10.title,
      minWidth = _ref10.minWidth,
      maxWidth = _ref10.maxWidth,
      selectedItem = _ref10.selectedItem,
      handleClose = _ref10.handleClose,
      selectItem = _ref10.selectItem,
      TitleIcon = _ref10.TitleIcon,
      _ref10$CloseButton = _ref10.CloseButton,
      CloseButton = _ref10$CloseButton === void 0 ? DefaultCloseButton : _ref10$CloseButton,
      props = _objectWithoutProperties(_ref10, _excluded);

  var s = useStyles(defaultStyles);
  var token = useToken();
  var titleToRender = selectedItem && (isCustomElementActionMenuItem(selectedItem) || isRegularAcctionMenuItem(selectedItem)) ? selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label : title;
  var handleBackClick = useCallback(function () {
    selectItem(null);
  }, [selectItem]);
  return /*#__PURE__*/React.createElement(Box, _extends({}, s.with('menu')({
    minWidth: minWidth,
    maxWidth: maxWidth,
    style: style,
    className: className
  }), props, {
    ref: ref,
    flexDirection: "column"
  }), /*#__PURE__*/React.createElement("div", _extends({}, s('titleContainer', {
    hidden: !(selectedItem || titleToRender),
    titleContainerHasSelectedItem: !!selectedItem
  }), {
    onClick: selectedItem ? handleBackClick : undefined
  }), /*#__PURE__*/React.createElement("div", s('backButton', {
    hidden: !selectedItem
  }), /*#__PURE__*/React.createElement(ChevronLeft, {
    size: "m"
  })), titleToRender && /*#__PURE__*/React.createElement(Box, {
    alignItems: "center"
  }, TitleIcon && /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    justifyContent: "center",
    mr: token('spacing.s')
  }, /*#__PURE__*/React.createElement(TitleIcon, null)), /*#__PURE__*/React.createElement(Truncate, null, /*#__PURE__*/React.createElement("span", s('title'), titleToRender)))), /*#__PURE__*/React.createElement("ul", s('items'), children), CloseButton && /*#__PURE__*/React.createElement(Breakpoints, {
    queries: {
      maxWidth: 's'
    }
  }, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: handleClose
  })));
});